/* global angular */

angular.module('gc.drop-upload', [])
.directive('dropUpload', ['CommentService', function (CommentService) {
  'use strict';
  return {
    restrict: 'A',
    scope: {
      callbacks: '&dropUpload',
    },
    link: function (scope, el, attrs) {

      el.on('dragover', function(e) {
        e.preventDefault();
        e.stopPropagation();
      });

      el.on('dragenter', function(e) {
        e.preventDefault();
        e.stopPropagation();
      });

      el.on('drop', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var callbacks = scope.callbacks();
        var dataTransfer = e.originalEvent.dataTransfer;

        if (callbacks.check() && dataTransfer){
          if (dataTransfer.files.length > 0) {
            for (var i = 0; i < dataTransfer.files.length; i++) {
              callbacks.init && callbacks.init();
              CommentService.addFile(dataTransfer.files[i])
                .success(function(resp) {
                  if (resp.status && resp.status === 413) {
                    callbacks.error(resp);
                  } else {
                    callbacks.done(resp);
                  }
                })
                .error(function(resp) {
                  callbacks.error(resp);
                })
              ;

              // only one upload at a time,
              // else the user can trick `website.embeded_files` limit
              // by uploading multiple files at once
              return;
            }
          }
        }
        return false;
      });
    }
  };
}]);
